/* Cart drawer: repairs a stale "empty" drawer, pulses the cart icon, styles the free shipping bar (fill sweep + sleigh),
   shows the UK/US delivery estimate, tidies the drawer and adds express checkout buttons. */
(function () {
  if (window.__fpCartSync) return;
  window.__fpCartSync = 1;

  var running = false;
  var timers = [];

  function rootUrl() {
    return (window.theme && theme.routes && theme.routes.root_url) || '/';
  }
  function mini() {
    return document.querySelector('[id^="MiniCart-"]');
  }
  function showsEmpty() {
    var m = mini();
    return !!(m && m.querySelector('.drawer__empty') && !m.querySelector('[id^="CartDrawer-Item-"]'));
  }

  async function repair() {
    var m = mini();
    var d = document.getElementById('CartDrawer');
    var sec = d && d.getAttribute('data-section-id');
    if (!m || !sec) return;
    var res = await fetch(rootUrl() + '?section_id=' + encodeURIComponent(sec) + '&fp=' + Date.now(), { cache: 'no-store' });
    var src = new DOMParser().parseFromString(await res.text(), 'text/html').getElementById(m.id);
    if (src && src.querySelector('[id^="CartDrawer-Item-"]')) m.innerHTML = src.innerHTML;
  }

  async function check() {
    if (running) return;
    running = true;
    try {
      if (showsEmpty()) {
        var c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
        if (c.item_count > 0) await repair();
      }
    } catch (e) {}
    running = false;
  }

  function schedule() {
    timers.forEach(clearTimeout);
    timers = [];
    [600, 1200, 2000, 3000, 4500, 6500, 9000, 13000].forEach(function (ms) {
      timers.push(setTimeout(check, ms));
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.product-form__submit, [name="add"], form[action*="/cart/add"] [type="submit"]')) schedule();
  }, true);
  ['ajaxProduct:added', 'cart:updated', 'cart:refresh'].forEach(function (n) {
    document.addEventListener(n, schedule);
  });

  var css = document.createElement('style');
  css.textContent =
    '.cart-drawer-button.fp-has-cart .icon-cart{color:#ff0a89}' +
    '.cart-drawer-button.fp-pulse::after{content:"";position:absolute;left:50%;top:50%;width:44px;height:44px;margin:-22px 0 0 -22px;border-radius:50%;background:#ff0a89;opacity:0;pointer-events:none;animation:fpRing 1s ease-out 3}' +
    '.cart-drawer-button.fp-pulse .icon-cart{color:#ff0a89;animation:fpIcon .5s ease-in-out 4}' +
    '.cart-drawer-button.fp-pulse cart-count{animation:fpIcon .5s ease-in-out 4}' +
    '@keyframes fpRing{0%{transform:scale(.5);opacity:.55}100%{transform:scale(1.7);opacity:0}}' +
    '@keyframes fpIcon{0%,100%{transform:scale(1)}50%{transform:scale(1.25)}}' +
    '.free-shipping-bar progress-bar{background-color:rgba(255,10,137,.12) !important}' +
    '.free-shipping-bar progress-bar::before{background-color:#ff0a89 !important;background-image:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0) 40%,rgba(255,255,255,.55) 50%,rgba(255,255,255,0) 60%,rgba(255,255,255,0) 100%) !important;background-size:250% 100% !important;background-repeat:no-repeat;background-position:100% 0}' +
    '.cart-drawer[active] .free-shipping-bar progress-bar::before{animation:fpFill .85s cubic-bezier(.22,1,.36,1) .3s 1 both,fpShine 1.3s ease-in-out 1.1s 1 both}' +
    '@keyframes fpFill{0%{clip-path:inset(0 100% 0 0 round 99px)}100%{clip-path:inset(0 0 0 0 round 99px)}}' +
    '@keyframes fpShine{0%{background-position:100% 0}100%{background-position:0 0}}' +
    '.drawer__footer-buttons a[href="/cart"]{display:none !important}' +
    '.drawer__footer-buttons button[name="checkout"]{grid-column:1 / -1 !important}' +
    '.drawer__footer-buttons{row-gap:8px !important}' +
    '#CartDrawer .drawer__footer-buttons button[name="checkout"]{background-color:#ff0a89 !important;border-color:#ff0a89 !important;color:#fff !important;min-height:38px !important;height:38px !important;padding-top:0 !important;padding-bottom:0 !important;border-radius:100px !important}' +
    '#CartDrawer .drawer__footer-buttons button[name="checkout"] .btn-fill{background-color:#d6006f !important}' +
    '#CartDrawer .drawer__footer-bottom{row-gap:12px !important}' +
    '#CartDrawer .drawer__footer-bottom .tax-note{display:none !important}' +
    '#CartDrawer .drawer__footer-bottom > div.grid{grid-template-columns:1fr !important}' +
    '#CartDrawer .drawer__footer-bottom .totals{display:flex !important;justify-content:space-between !important;align-items:baseline !important;place-self:stretch !important;width:100%}' +
    '#CartDrawer .drawer__header{padding-top:20px !important;padding-bottom:8px !important}' +
    '#CartDrawer .drawer__tabs li{height:auto !important;min-height:0 !important}' +
    '.drawer__footer-buttons .fp-express{margin:0}' +
    '#CartDrawer product-recommendations.complementary-products{display:none !important}' +
    '#CartDrawer .fp-express shopify-accelerated-checkout-cart{--shopify-accelerated-checkout-button-block-size:38px !important;--shopify-accelerated-checkout-row-gap:6px !important;--shopify-accelerated-checkout-button-border-radius:100px !important}' +
    '.free-shipping-bar .fp-fs-eta{display:inline;margin-left:6px;opacity:.85}' +
    '@media (max-width:749px){.free-shipping-bar .fp-fs-eta{display:block;margin-left:0;margin-top:2px;font-size:13px;line-height:1.35}}' +
    '@media (prefers-reduced-motion:reduce){.cart-drawer-button.fp-pulse::after,.cart-drawer-button.fp-pulse .icon-cart,.cart-drawer-button.fp-pulse cart-count{animation:none}.cart-drawer-button.fp-pulse .icon-cart{color:#ff0a89}.cart-drawer[active] .free-shipping-bar progress-bar::before{animation:none}}';
  document.head.appendChild(css);

  /* When an item is added, the sleigh / confetti script (fp-celebrate.js) is loaded once and played; it costs nothing on page load. */
  var CEL = (document.currentScript && document.currentScript.src) || '';
  var celLoading = 0;
  function celebrate() {
    if (window.fpCelebrate) return window.fpCelebrate();
    if (!CEL || celLoading) return;
    celLoading = 1;
    var sc = document.createElement('script');
    sc.src = CEL.split('?')[0].replace('fp-cart-sync.js', 'fp-celebrate.js') + '?v=3';
    sc.onload = function () { if (window.fpCelebrate) window.fpCelebrate(); };
    document.head.appendChild(sc);
  }

  /* Free shipping message; UK/US visitors also get the delivery estimate (slowest finish in the cart counts). */
  var FS_TEXT = 'You’ve got free shipping 🎉';
  var RANGES = { print: [1, 3], mid: [2, 5], high: [3, 7] };
  var RANK = { print: 0, mid: 1, high: 2 };
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var etaStartAt = 0;
  var etaStartVal = null;
  var etaT = 0;
  var etaPend = 0;
  function etaMarket() {
    var c = (window.Shopify && Shopify.country) || '';
    return c === 'GB' || c === 'US';
  }
  function isWeekend(d) { return d.getUTCDay() === 0 || d.getUTCDay() === 6; }
  function addWd(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (!isWeekend(x)) n--; }
    return x;
  }
  function etaStart() {
    if (etaStartVal && Date.now() - etaStartAt < 60000) return etaStartVal;
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false }).formatToParts(new Date()), o = {};
    parts.forEach(function (x) { o[x.type] = x.value; });
    var d = new Date(Date.UTC(+o.year, +o.month - 1, +o.day, 12));
    if (isWeekend(d) || (+o.hour) % 24 >= 17) d = addWd(d, 1);
    etaStartVal = d;
    etaStartAt = Date.now();
    return d;
  }
  function tierOfText(t) {
    if (/unframed/i.test(t)) return 'print';
    if (/float|box/i.test(t)) return 'high';
    if (/frame|canvas/i.test(t)) return 'mid';
    return 'print';
  }
  function cartTier() {
    var items = document.querySelectorAll('#CartDrawer [id^="CartDrawer-Item-"]'), worst = 0, i, k, w, nodes, tx, t;
    for (i = 0; i < items.length; i++) {
      w = document.createTreeWalker(items[i], NodeFilter.SHOW_TEXT);
      nodes = [];
      while (w.nextNode()) {
        tx = w.currentNode.nodeValue.replace(/\s+/g, ' ').trim();
        if (tx) nodes.push(tx);
      }
      for (k = 0; k < nodes.length; k++) {
        t = '';
        if (/framing service add on|floater framed|float framed canvas|premium box frame|classic framed/i.test(nodes[k])) t = nodes[k];
        else if (/^(print finish|finish|frame)/i.test(nodes[k])) t = nodes[k] + ' ' + (nodes[k + 1] || '');
        if (t && RANK[tierOfText(t)] > worst) worst = RANK[tierOfText(t)];
      }
    }
    return worst === 2 ? 'high' : worst === 1 ? 'mid' : 'print';
  }
  function etaHtml() {
    var r = RANGES[cartTier()], s0 = etaStart(), a = addWd(s0, r[0]), b = addWd(s0, r[1]);
    var s = a.getUTCMonth() === b.getUTCMonth() ? a.getUTCDate() + '–' + b.getUTCDate() + ' ' + MON[b.getUTCMonth()] : a.getUTCDate() + ' ' + MON[a.getUTCMonth()] + ' – ' + b.getUTCDate() + ' ' + MON[b.getUTCMonth()];
    return FS_TEXT + '<span class="fp-fs-eta">Order today to get it by <b>' + s + '</b></span>';
  }
  function rewordShipping(root, forced) {
    var spans = (root || document).querySelectorAll('.free-shipping-bar > span'), market = etaMarket(), html, s, i;
    for (i = 0; i < spans.length; i++) {
      s = spans[i];
      if (market && (s.hasAttribute('data-fp-eta') || /eligible for free shipping/i.test(s.textContent))) {
        if (!forced && Date.now() - etaT < 250) {
          if (!etaPend) etaPend = setTimeout(function () { etaPend = 0; rewordShipping(null, true); }, 260);
          continue;
        }
        etaT = Date.now();
        html = etaHtml();
        if (s.getAttribute('data-fp-eta') !== html) { s.innerHTML = html; s.setAttribute('data-fp-eta', html); }
      } else if (/eligible for free shipping/i.test(s.textContent) && s.textContent.trim() !== FS_TEXT) {
        s.textContent = FS_TEXT;
      }
    }
  }

  /* Express checkout buttons under Checkout in the drawer. */
  var expressHtml = '';
  var expressAt = 0;
  var expressBusy = false;
  var expressTried = 0;
  var expressRetry = 0;
  function getExpress() {
    if (expressHtml && Date.now() - expressAt < 300000) return Promise.resolve(expressHtml);
    return fetch(rootUrl() + '?section_id=fp-express-checkout&fp=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        if (t && t.indexOf('additional-checkout-buttons') !== -1) { expressHtml = t; expressAt = Date.now(); return t; }
        return '';
      });
  }
  function injectExpress() {
    if (expressBusy) return;
    var forms = document.querySelectorAll('#CartDrawer .drawer__footer-buttons');
    var need = [];
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].querySelector('.fp-express')) need.push(forms[i]);
    }
    if (!need.length) return;
    if (!document.querySelector('#CartDrawer [id^="CartDrawer-Item-"]')) return;
    var cached = expressHtml && Date.now() - expressAt < 300000;
    if (!cached && Date.now() - expressTried < 10000) {
      if (!expressRetry) {
        expressRetry = setTimeout(function () { expressRetry = 0; injectExpress(); }, 10200);
      }
      return;
    }
    expressTried = Date.now();
    expressBusy = true;
    getExpress().then(function (t) {
      if (!t) return;
      var list = document.querySelectorAll('#CartDrawer .drawer__footer-buttons');
      for (var j = 0; j < list.length; j++) {
        var f = list[j];
        if (f.querySelector('.fp-express')) continue;
        var tmp = document.createElement('div');
        tmp.innerHTML = t;
        var src = tmp.querySelector('.additional-checkout-buttons');
        if (!src) continue;
        var wrap = document.createElement('div');
        wrap.className = 'fp-express col-span-full';
        wrap.appendChild(src);
        f.appendChild(wrap);
      }
    }).catch(function () {}).then(function () { expressBusy = false; });
  }

  rewordShipping();
  injectExpress();
  new MutationObserver(function () { rewordShipping(); injectExpress(); }).observe(document.documentElement, { childList: true, subtree: true });

  function countNow() {
    var el = document.querySelector('.cart-drawer-button cart-count');
    var n = el ? parseInt((el.textContent || '').replace(/\D/g, ''), 10) : 0;
    return isNaN(n) ? 0 : n;
  }
  function markCart() {
    var has = countNow() > 0;
    var btns = document.querySelectorAll('.cart-drawer-button');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].classList.contains('fp-has-cart') !== has) btns[i].classList.toggle('fp-has-cart', has);
    }
  }
  function drawerClosed() {
    var d = document.getElementById('CartDrawer');
    return !d || !d.hasAttribute('open');
  }
  function pulse() {
    var btns = document.querySelectorAll('.cart-drawer-button');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.classList.remove('fp-pulse');
        void b.offsetWidth;
        b.classList.add('fp-pulse');
        setTimeout(function () { b.classList.remove('fp-pulse'); }, 2200);
      })(btns[i]);
    }
  }
  var waiting = false;
  function pulseWhenVisible() {
    if (waiting) return;
    waiting = true;
    var tries = 0;
    (function loop() {
      tries++;
      if (drawerClosed() || tries > 60) { waiting = false; pulse(); return; }
      setTimeout(loop, 400);
    })();
  }

  markCart();
  var last = countNow();
  var burstUntil = 0;
  setInterval(function () {
    var n = countNow();
    markCart();
    if (n > last) { pulseWhenVisible(); burstUntil = Date.now() + 10000; }
    last = n;
    if (burstUntil && Date.now() > burstUntil) burstUntil = 0;
    if (burstUntil && !drawerClosed()) { burstUntil = 0; setTimeout(celebrate, 700); }
  }, 400);
})();